import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from 'react-hook-form'
import { Checkbox, FormControlLabel } from '@mui/material'

interface PermissionControllerCheckboxProps<TFieldValues extends FieldValues> {
  onChange: () => void
  name: Path<TFieldValues>
  label: string
  control: Control<TFieldValues>
}

export const PermissionControllerCheckbox = <TFieldValues extends FieldValues>({
  onChange,
  label,
  name,
  control,
}: PermissionControllerCheckboxProps<TFieldValues>) => {
  return (
    <Controller
      render={({ field: { value } }) => {
        return (
          <FormControlLabel
            sx={{ pt: '6px' }}
            control={<Checkbox checked={value} onChange={onChange} />}
            label={label}
          />
        )
      }}
      name={name}
      control={control}
    />
  )
}
